/* Andes - Popup de registro: una vez al dia, hasta que el visitante se registre.
   Estado en localStorage (por navegador, que es lo unico disponible sin sesion):
     andes_popup_sub = "1"      -> ya se registro, no vuelve a salir nunca
     andes_popup_day = "AAAA-MM-DD" -> ultimo dia en que se mostro
   Todo acceso va en try/catch: en navegacion privada localStorage puede lanzar. */
(() => {
  const KEY_SUB = 'andes_popup_sub';
  const KEY_DAY = 'andes_popup_day';

  const leer = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
  const guardar = (k, v) => { try { localStorage.setItem(k, v); } catch { /* sin storage: se mostrara otra vez */ } };
  const hoy = () => new Date().toISOString().slice(0, 10);

  const iniciar = () => {
    const popup = document.querySelector('[data-andes-popup]');
    if (!popup || typeof popup.showModal !== 'function') return;

    // Shopify vuelve con ?customer_posted=true tras un alta correcta
    const exito = new URLSearchParams(location.search).get('customer_posted') === 'true';
    if (exito) guardar(KEY_SUB, '1');

    const cerrar = () => { if (popup.open) popup.close(); };
    popup.querySelectorAll('[data-andes-popup-close]').forEach((b) => b.addEventListener('click', cerrar));
    // clic en el fondo (fuera de la tarjeta)
    popup.addEventListener('click', (e) => { if (e.target === popup) cerrar(); });

    // si volvio del formulario, mostramos el estado de exito de inmediato
    if (exito) { popup.showModal(); return; }

    if (leer(KEY_SUB) === '1') return;                  // ya registrado
    if (popup.dataset.loggedIn === 'true') return;       // sesion iniciada
    if (leer(KEY_DAY) === hoy()) return;                 // ya lo vio hoy

    const espera = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
    setTimeout(() => {
      if (document.querySelector('dialog[open]')) return; // no pisar otro modal
      guardar(KEY_DAY, hoy());
      popup.showModal();
    }, espera);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
